import React from 'react'

export default function SetAllowGroupTransfer() {
  return (
    <div>setAllowGroupTransfer</div>
  )
}
